import { ref } from 'vue'

const isInColumnsManageStatus = ref(false)

function setInColumnsStatusValue(value: boolean) {
    isInColumnsManageStatus.value = value
}

export function useColumnsStatusManage() {
    return {
        isInColumnsManageStatus,
        setInColumnsStatusValue,
    }
}
